// extracted by mini-css-extract-plugin
var _1 = "ReplacementProductDetail_btnSection__BUhsV";
var _2 = "ReplacementProductDetail_buttonWrapper__Bh-6-";
var _3 = "ReplacementProductDetail_closeBtn__dhKKl";
var _4 = "ReplacementProductDetail_container__KC4zN";
var _5 = "ReplacementProductDetail_icon__a58iu fa fa-chevron-left";
var _6 = "ReplacementProductDetail_mobileContainer__KsWRD";
var _7 = "ReplacementProductDetail_modalWrapper__nnjaQ";
var _8 = "ReplacementProductDetail_productsWrapper__BbLHk";
var _9 = "ReplacementProductDetail_replacementDetailsModal__boXZf";
export { _1 as "btnSection", _2 as "buttonWrapper", _3 as "closeBtn", _4 as "container", _5 as "icon", _6 as "mobileContainer", _7 as "modalWrapper", _8 as "productsWrapper", _9 as "replacementDetailsModal" }
